var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7028_14723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9463 6.22684C15.4771 6.1439 14.9938 6.10059 14.5001 6.10059C13.9461 6.10059 13.4052 6.15513 12.8825 6.25903V12.5709H6.54939C6.46115 13.0392 6.41504 13.5221 6.41504 14.0155C6.41504 14.5704 6.47338 15.112 6.58437 15.6347H12.8825V21.7719C13.4052 21.8758 13.9461 21.9304 14.5001 21.9304C14.9938 21.9304 15.4771 21.887 15.9463 21.8041V15.6347H22.4159C22.5269 15.112 22.5852 14.5704 22.5852 14.0155C22.5852 13.5221 22.5391 13.0392 22.4509 12.5709H15.9463V6.22684Z",
    fill: "url(#paint0_linear_7028_14723)",
    fillOpacity: 0.56
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9461 6.2952C15.4768 6.21225 14.9935 6.16895 14.4999 6.16895C13.9459 6.16895 13.4049 6.22349 12.8823 6.32739V12.6382H6.54935C6.46098 13.1069 6.41479 13.5901 6.41479 14.0838C6.41479 14.6384 6.47305 15.1796 6.58391 15.702H12.8823V21.8403C13.4049 21.9442 13.9459 21.9987 14.4999 21.9987C14.9935 21.9987 15.4768 21.9554 15.9461 21.8725V15.702H22.4159C22.5267 15.1796 22.585 14.6384 22.585 14.0838C22.585 13.5901 22.5388 13.1069 22.4504 12.6382H15.9461V6.2952Z",
    fill: "url(#paint1_linear_7028_14723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7028_14723",
    x: 0.627706,
    y: 0.313252,
    width: 27.7448,
    height: 27.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.89367,
    result: "effect1_foregroundBlur_7028_14723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7028_14723",
    x1: 6.41504,
    y1: 14.441,
    x2: 22.5852,
    y2: 14.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7028_14723",
    x1: 6.41479,
    y1: 14.5094,
    x2: 22.585,
    y2: 14.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5F3FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.099afe83e9078d4e16c23f7a293ea7b4.svg";
export { ForwardRef as ReactComponent };